<template>
  <div class="sortable-list">
    <v-progress-linear v-if="filters.filter_loading_status" :indeterminate="true"></v-progress-linear>
    <v-progress-linear v-if="filters.filters_loading_status" :indeterminate="true"></v-progress-linear>
    <draggable v-model="filters_data" v-else-if="filters_data.length !== 0" @sort="reorderFilter">
      <transition-group>
        <div class="sortable-item" v-for="(item, index) in filters_data" :key="`k-${index}`">
          <div class="sortable-inner">
            <div class="sortable-icon">
              <v-icon>mdi-unfold-more-horizontal</v-icon>
            </div>
            <div class="sortable-name">
              {{ item.filtername }}
            </div>
          </div>
          <div class="sortable-actions">
            <gg-btn icon  @click="getFilter(account, item.filtername)">
              <v-icon color="primary">mdi-pencil</v-icon>
            </gg-btn>
            <gg-btn icon  @click="openDeleteModal(account, item.filtername)">
              <v-icon color="primary">mdi-delete</v-icon>
            </gg-btn>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="text-center" v-else>
      No filters found
    </div>
    <template>
      <v-dialog v-model="modal" max-width="500px">
        <delete-modal v-if="modal" :account="account" :filtername="filtername" @close="closeDeleteModal"/>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'
import { scrollTo } from 'Helpers/helpers'
import DeleteModal from './Modals/DeleteModal'

export default {
  name: 'Table',
  components: {
    draggable, DeleteModal
  },
  data: () => ({
    filters_data: [],
    loaded: false,
    modal: false,
    account_name: '',
    filtername: '',
  }),
  computed: {
    ...mapGetters({
      filters: 'email/filters',
    }),
    // A query parameter on the hosting route, a path parameter on the Email
    // section's `filters/:account`.
    account () {
      return this.$route.query.account || this.$route.params.account
    },
  },
  methods: {
    scrollTo,
    ...mapActions({
      setFilters: 'email/setFilters',
      setFilter: 'email/setFilter',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
      cpanel_uapi: 'cpanel_uapi',
    }),
    async getData () {
      try {
        await this.setFilters({ account: this.account, _username: this.$route.query.user })
        this.loaded = true
      } catch (e) {
        this.reportError(e)
      }
    },
    async getFilter (account, filter) {
      try {
        await this.setFilter({ account, filter, _username: this.$route.query.user })
        this.$emit('edit', filter)

        // A page may keep the form hidden until a filter is picked (AM-1107).
        if (document.querySelector('#create-filter')) {
          await this.scrollTo('#create-filter')
        }
      } catch (e) {
        this.reportError(e)
      }
    },
    async reorderFilter () {
      let filtersOrder = {}

      for (let key in this.filters_data) {
        filtersOrder['uapi_module'] = 'Email'
        filtersOrder['uapi_function'] = 'reorder_filters'
        filtersOrder['mailbox'] = this.account
        filtersOrder[`filter${key}`] = this.filters_data[key].filtername
      }

      try {
        await this.cpanel_uapi({ ...filtersOrder, _username: this.$route.query.user })
        this.reportSuccess('Order changed')
      } catch (e) {
        this.reportError(e.resultmsg)
      }
    },
    openDeleteModal (account, filtername) {
      this.modal = true
      this.account_name = account
      this.filtername = filtername
    },
    closeDeleteModal () {
      this.modal = false
      this.account_name = ''
      this.filtername = ''
    }
  },
  watch: {
    'filters.list': function () {
      this.filters_data = this.filters.list
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
  .sortable-list {
    > div {
      width: 100%;
    }
    .sortable-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      width: 100%;
      padding: 0 15px;
      border: 1px solid lightgray;
      cursor: move;
      margin-bottom: 15px;
    }
    .sortable-inner {
      display: flex;
    }
    .sortable-name {
      padding: 0 15px;
    }
    .sortable-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .sortable-ghost {
      background: lightgray;
      &.sortable-item {
        border: 1px dashed;
      }
      .sortable-inner, .sortable-actions {
        visibility: hidden;
        opacity: 0;
      }
    }
  }

  .sortable-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 10px 15px;
    border: 1px solid lightgray;
    margin-bottom: 15px;
  }
</style>
